// components/MapPreview.js
//
// The venue on a map: Google's embedded map (Maps Embed API - free and
// unmetered), with Get Directions.
//
// Was Leaflet with OpenStreetMap tiles, loaded from unpkg on every open and
// drawn with the attribution the OSM licence requires switched off. Why the
// embed instead, and the keyless fallback when no key is configured, are in
// shared/mapEmbed.js - the same URL the app's VenueMap loads.
import React, { useState } from 'react';
import { FiNavigation, FiMapPin } from 'react-icons/fi';
import { mapEmbedUrl } from '../shared/mapEmbed';
import '../styles/MapPreview.scss';

const MapPreview = ({ location, name, address, height = 200, showDirectionsButton = true }) => {
  const [loaded, setLoaded] = useState(false);

  const hasCoords = location && location.lat != null && location.lng != null;
  const src = hasCoords
    ? mapEmbedUrl({
        key: process.env.REACT_APP_GOOGLE_MAPS_EMBED_KEY || null,
        lat: location.lat,
        lng: location.lng,
        name: address || name,
      })
    : null;

  const handleGetDirections = () => {
    if (!hasCoords) return;
    const query = address || `${location.lat},${location.lng}`;
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(query)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (!src) {
    return (
      <div className="map-preview-placeholder" style={{ height }}>
        <FiMapPin size={48} />
        <p>No location set</p>
      </div>
    );
  }

  return (
    <div className="map-preview-container">
      <div className="map-wrapper" style={{ height }}>
        {/* Hidden until loaded, over the wrapper's own colour, so there is no
            blank frame to flash while the page scrolls past it. */}
        <iframe
          className="map-element"
          title={`Map of ${address || name || 'the venue'}`}
          src={src}
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          onLoad={() => setLoaded(true)}
          style={{ border: 0, opacity: loaded ? 1 : 0, transition: 'opacity 200ms ease' }}
        />
      </div>

      <div className="map-info">
        <div className="location-details">
          <h4>{name || 'Event Location'}</h4>
          {address && <p>{address}</p>}
        </div>

        {showDirectionsButton && (
          <button type="button" className="directions-btn" onClick={handleGetDirections}>
            <FiNavigation />
            <span>Get Directions</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default MapPreview;
